import { ReactComponent as IconRulePeopleCount } from "@resources/icons/svg/rule/icon-rule-people-counting.svg";
import { ReactComponent as IconRuleQueue } from "@resources/icons/svg/rule/icon-rule-queue-management.svg";
import { ReactComponent as IconRuleSlipAndFall } from "@resources/icons/svg/rule/icon-rule-slip-and-fall.svg";
import { ReactComponent as IconRuleCrowd } from "@resources/icons/svg/rule/icon-rule-crowd.svg";
import { ReactComponent as IconRuleShoppingCart } from "@resources/icons/svg/rule/icon-rule-shopping-cart.svg";
import { ReactComponent as IconRuleVehicle } from "@resources/icons/svg/rule/icon-rule-vehicle.svg";
import { ReactComponent as IconRuleTrafficJam } from "@resources/icons/svg/rule/icon-rule-traffic-jam.svg";
import {
  ANALYTICS_CHART_TYPE,
  TIME_INTERVAL,
  TYPE_TIME_INTERVAL
} from "@resources/Constants";
import { createElement } from "react";
import { AnalyticsCategoryDataResponse } from "@queries/Analytics";
import { ChartCardProps } from "./Interfaces";

export const defaultDataVehicleType = [
  "all",
  "car",
  "bus",
  "truck",
  "motorcycle",
  "bicycle"
];

const commonProps = {
  timeInterval: TIME_INTERVAL.DAY_1,
  typeInterval: TYPE_TIME_INTERVAL.HOUR
};

const CoutByCategory: AnalyticsCategoryDataResponse = [
  {
    idx: 0,
    count: 395,
    intervalName: "00:00 - 00:59",
    rate: 7.31
  },
  {
    idx: 1,
    count: 400,
    intervalName: "01:00 - 01:59",
    rate: 7.4
  },
  {
    idx: 2,
    count: 399,
    intervalName: "02:00 - 02:59",
    rate: 7.38
  },
  {
    idx: 3,
    count: 396,
    intervalName: "03:00 - 03:59",
    rate: 7.33
  },
  {
    idx: 4,
    count: 382,
    intervalName: "04:00 - 04:59",
    rate: 7.07
  },
  {
    idx: 5,
    count: 391,
    intervalName: "05:00 - 05:59",
    rate: 7.24
  },
  {
    idx: 6,
    count: 387,
    intervalName: "06:00 - 06:59",
    rate: 7.16
  },
  {
    idx: 7,
    count: 416,
    intervalName: "07:00 - 07:59",
    rate: 7.7
  },
  {
    idx: 8,
    count: 409,
    intervalName: "08:00 - 08:59",
    rate: 7.57
  },
  {
    idx: 9,
    count: 417,
    intervalName: "09:00 - 09:59",
    rate: 7.72
  },
  {
    idx: 10,
    count: 394,
    intervalName: "10:00 - 10:59",
    rate: 7.29
  },
  {
    idx: 11,
    count: 393,
    intervalName: "11:00 - 11:59",
    rate: 7.27
  },
  {
    idx: 12,
    count: 387,
    intervalName: "12:00 - 12:59",
    rate: 7.16
  },
  {
    idx: 13,
    count: 238,
    intervalName: "13:00 - 13:59",
    rate: 4.4
  },
  {
    idx: 14,
    count: 0,
    intervalName: "14:00 - 14:59",
    rate: 0
  },
  {
    idx: 15,
    count: 0,
    intervalName: "15:00 - 15:59",
    rate: 0
  },
  {
    idx: 16,
    count: 0,
    intervalName: "16:00 - 16:59",
    rate: 0
  },
  {
    idx: 17,
    count: 0,
    intervalName: "17:00 - 17:59",
    rate: 0
  },
  {
    idx: 18,
    count: 0,
    intervalName: "18:00 - 18:59",
    rate: 0
  },
  {
    idx: 19,
    count: 0,
    intervalName: "19:00 - 19:59",
    rate: 0
  },
  {
    idx: 20,
    count: 0,
    intervalName: "20:00 - 20:59",
    rate: 0
  },
  {
    idx: 21,
    count: 0,
    intervalName: "21:00 - 21:59",
    rate: 0
  },
  {
    idx: 22,
    count: 0,
    intervalName: "22:00 - 22:59",
    rate: 0
  },
  {
    idx: 23,
    count: 0,
    intervalName: "23:00 - 23:59",
    rate: 0
  }
];

export const previewCumulativePeopleCount: ChartCardProps = {
  title: "Cumulative people count",
  analyticsData: [
    {
      locationName: "Nonjinmul Beach",
      key: "Nonjinmul Beach",
      total: 400,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 10, 20, 0, 120, 30, 40, 0, 0, 0, 0, 0, 0, 155, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 20, 20, 4
      ],
      color: "#ff6d10"
    },
    {
      locationName: "Hanwha Vision (HQ)",
      key: "Hanwha Vision (HQ)",
      total: 1786,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 23, 3, 55, 0, 45, 23, 77, 4, 5, 22,
        44, 55, 6, 21, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30, 50, 0, 0, 0
      ],
      color: "#afed23"
    },
    {
      locationName: "EInfochips",
      key: "EInfochips",
      total: 354,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 75, 75,
        0, 0, 162, 35, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 60, 0, 0, 0, 3
      ],
      color: "#eeda12"
    }
  ],
  baseTime: {
    start: "2024-09-26T00:00:00.000+05:30",
    end: "2024-12-24T23:59:59.999+05:30",
    mode: "custom"
  },
  type: ANALYTICS_CHART_TYPE.CUMULATIVE_PEOPLE_COUNT as keyof typeof ANALYTICS_CHART_TYPE,
  categoryData: CoutByCategory,
  dataSeries: ["Nonjinmul Beach", "Hanwha Vision (HQ)", "EInfochips"],
  icon: createElement(IconRulePeopleCount),
  ...commonProps
};

export const previewPeopleOccupancy: ChartCardProps = {
  title: "People occupancy",
  analyticsData: [
    {
      locationName: "Nonjinmul Beach",
      key: "Nonjinmul Beach",
      total: 400,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 10, 20, 0, 120, 30, 40, 0, 0, 0, 0, 0, 0, 155, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 20, 20, 4
      ],
      color: "#ff6d10"
    },
    {
      locationName: "Hanwha Vision (HQ)",
      key: "Hanwha Vision (HQ)",
      total: 1786,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 23, 3, 55, 0, 45, 23, 77, 4, 5, 22,
        44, 55, 6, 21, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30, 50, 0, 0, 0
      ],
      color: "#afed23"
    },
    {
      locationName: "EInfochips",
      key: "EInfochips",
      total: 354,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 75, 75,
        0, 0, 162, 35, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 60, 0, 0, 0, 3
      ],
      color: "#eeda12"
    }
  ],
  baseTime: {
    start: "2024-09-26T00:00:00.000+05:30",
    end: "2024-12-24T23:59:59.999+05:30",
    mode: "custom"
  },
  type: ANALYTICS_CHART_TYPE.PEOPLE_OCCUPANCY as keyof typeof ANALYTICS_CHART_TYPE,
  categoryData: CoutByCategory,
  dataSeries: ["Nonjinmul Beach", "Hanwha Vision (HQ)", "EInfochips"],
  icon: createElement(IconRuleCrowd),
  ...commonProps
};

export const previewPeopleFlow: ChartCardProps = {
  title: "People flow",
  analyticsData: [
    {
      locationName: "Nonjinmul Beach",
      key: "Nonjinmul Beach",
      total: 400,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 10, 20, 0, 120, 30, 40, 0, 0, 0, 0, 0, 0, 155, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 20, 20, 4
      ],
      color: "#ff6d10"
    },
    {
      locationName: "Hanwha Vision (HQ)",
      key: "Hanwha Vision (HQ)",
      total: 1786,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 23, 3, 55, 0, 45, 23, 77, 4, 5, 22,
        44, 55, 6, 21, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30, 50, 0, 0, 0
      ],
      color: "#afed23"
    },
    {
      locationName: "EInfochips",
      key: "EInfochips",
      total: 354,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 75, 75,
        0, 0, 162, 35, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 60, 0, 0, 0, 3
      ],
      color: "#eeda12"
    }
  ],
  baseTime: {
    start: "2024-09-26T00:00:00.000+05:30",
    end: "2024-12-24T23:59:59.999+05:30",
    mode: "custom"
  },
  dataSeries: ["Nonjinmul Beach", "Hanwha Vision (HQ)", "EInfochips"],
  icon: createElement(IconRulePeopleCount),
  ...commonProps
};

export const previewPeopleQueues: ChartCardProps = {
  title: "People queues",
  analyticsData: [
    {
      locationName: "Nonjinmul Beach",
      key: "Nonjinmul Beach",
      total: 400,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 10, 20, 0, 120, 30, 40, 0, 0, 0, 0, 0, 0, 155, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 20, 20, 4
      ],
      color: "#ff6d10"
    },
    {
      locationName: "Hanwha Vision (HQ)",
      key: "Hanwha Vision (HQ)",
      total: 1786,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 23, 3, 55, 0, 45, 23, 77, 4, 5, 22,
        44, 55, 6, 21, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30, 50, 0, 0, 0
      ],
      color: "#afed23"
    },
    {
      locationName: "EInfochips",
      key: "EInfochips",
      total: 354,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 75, 75,
        0, 0, 162, 35, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 60, 0, 0, 0, 3
      ],
      color: "#eeda12"
    }
  ],
  baseTime: {
    start: "2024-09-26T00:00:00.000+05:30",
    end: "2024-12-24T23:59:59.999+05:30",
    mode: "custom"
  },
  dataSeries: ["Nonjinmul Beach", "Hanwha Vision (HQ)", "EInfochips"],
  icon: createElement(IconRuleQueue),
  ...commonProps
};

export const previewRetailVisitorAreaTraffic: ChartCardProps = {
  title: "Visitor area traffic",
  options: {
    viewList: ["count", "wait_time"]
  },
  viewType: "count",
  analyticsData: [
    {
      locationName: "EInfochips",
      key: "EInfochips",
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0
      ],
      originalData: [
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        }
      ],
      color: "#7dc519"
    },
    {
      locationName: "Zinc House Farm",
      key: "Zinc House Farm",
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0
      ],
      originalData: [
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        }
      ],
      color: "#4891ff"
    },
    {
      locationName: "Busan",
      key: "Busan",
      chartData: [
        0, 2.56, 2.47, 0, 0, 0, 0, 0, 2.24, 2.31, 2.27, 2.35, 2.36, 2.44, 2.43,
        2.4, 2.35, 2.28, 2.31, 2.29, 0, 0, 0, 6.42, 6.31, 6.39, 6.31, 7.48,
        7.49, 6.14
      ],
      originalData: [
        {
          count: 0,
          time: 0
        },
        {
          count: 2.56,
          time: 7.83
        },
        {
          count: 2.47,
          time: 7.6
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 2.24,
          time: 7.1
        },
        {
          count: 2.31,
          time: 7.48
        },
        {
          count: 2.27,
          time: 7.45
        },
        {
          count: 2.35,
          time: 6.66
        },
        {
          count: 2.36,
          time: 7.9
        },
        {
          count: 2.44,
          time: 8.36
        },
        {
          count: 2.43,
          time: 8.46
        },
        {
          count: 2.4,
          time: 9.61
        },
        {
          count: 2.35,
          time: 5.14
        },
        {
          count: 2.28,
          time: 4.34
        },
        {
          count: 2.31,
          time: 4.35
        },
        {
          count: 2.29,
          time: 4.35
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 0,
          time: 0
        },
        {
          count: 6.42,
          time: 7.27
        },
        {
          count: 6.31,
          time: 7.19
        },
        {
          count: 6.39,
          time: 7.37
        },
        {
          count: 6.31,
          time: 7.32
        },
        {
          count: 7.48,
          time: 8.27
        },
        {
          count: 7.49,
          time: 7.96
        },
        {
          count: 6.14,
          time: 6.93
        }
      ],
      color: "#00b960"
    }
  ],
  baseTime: {
    start: "2024-09-26T00:00:00.000+05:30",
    end: "2024-12-24T23:59:59.999+05:30",
    mode: "custom"
  },
  dataSeries: ["EInfochips", "Zinc House Farm", "Busan"],
  type: ANALYTICS_CHART_TYPE.RETAIL_VISITOR_AREA_TRAFFIC as keyof typeof ANALYTICS_CHART_TYPE,
  icon: createElement(IconRuleQueue),
  ...commonProps
};

export const previewSlipAndFall: ChartCardProps = {
  title: "Slip & fall",
  analyticsData: [
    {
      locationName: "Nonjinmul Beach",
      key: "Nonjinmul Beach",
      total: 400,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 10, 20, 0, 120, 30, 40, 0, 0, 0, 0, 0, 0, 155, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 20, 20, 4
      ],
      color: "#ff6d10"
    },
    {
      locationName: "Hanwha Vision (HQ)",
      key: "Hanwha Vision (HQ)",
      total: 1786,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 23, 3, 55, 0, 45, 23, 77, 4, 5, 22,
        44, 55, 6, 21, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30, 50, 0, 0, 0
      ],
      color: "#afed23"
    },
    {
      locationName: "EInfochips",
      key: "EInfochips",
      total: 354,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 75, 75,
        0, 0, 162, 35, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 60, 0, 0, 0, 3
      ],
      color: "#eeda12"
    }
  ],
  baseTime: {
    start: "2024-09-26T00:00:00.000+05:30",
    end: "2024-12-24T23:59:59.999+05:30",
    mode: "custom"
  },
  dataSeries: ["Nonjinmul Beach", "Hanwha Vision (HQ)", "EInfochips"],
  type: ANALYTICS_CHART_TYPE.SLIP_AND_FALL as keyof typeof ANALYTICS_CHART_TYPE,
  icon: createElement(IconRuleSlipAndFall),
  ...commonProps
};

export const previewCrowdCounting: ChartCardProps = {
  title: "Crowd counting",
  analyticsData: [
    {
      locationName: "Nonjinmul Beach",
      key: "Nonjinmul Beach",
      total: 400,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 10, 20, 0, 120, 30, 40, 0, 0, 0, 0, 0, 0, 155, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 20, 20, 4
      ],
      color: "#ff6d10"
    },
    {
      locationName: "Hanwha Vision (HQ)",
      key: "Hanwha Vision (HQ)",
      total: 1786,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 23, 3, 55, 0, 45, 23, 77, 4, 5, 22,
        44, 55, 6, 21, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30, 50, 0, 0, 0
      ],
      color: "#afed23"
    },
    {
      locationName: "EInfochips",
      key: "EInfochips",
      total: 354,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 75, 75,
        0, 0, 162, 35, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 60, 0, 0, 0, 3
      ],
      color: "#eeda12"
    }
  ],
  baseTime: {
    start: "2024-09-26T00:00:00.000+05:30",
    end: "2024-12-24T23:59:59.999+05:30",
    mode: "custom"
  },
  dataSeries: ["Nonjinmul Beach", "Hanwha Vision (HQ)", "EInfochips"],
  type: ANALYTICS_CHART_TYPE.CROWD_COUNTING as keyof typeof ANALYTICS_CHART_TYPE,
  icon: createElement(IconRuleCrowd),
  ...commonProps
};

export const previewCumulativeShoppingCartCount: ChartCardProps = {
  title: "Cumulative shopping cart count",
  analyticsData: [
    {
      locationName: "Nonjinmul Beach",
      key: "Nonjinmul Beach",
      total: 400,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 10, 20, 0, 120, 30, 40, 0, 0, 0, 0, 0, 0, 155, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 20, 20, 4
      ],
      color: "#ff6d10"
    },
    {
      locationName: "Hanwha Vision (HQ)",
      key: "Hanwha Vision (HQ)",
      total: 1786,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 23, 3, 55, 0, 45, 23, 77, 4, 5, 22,
        44, 55, 6, 21, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30, 50, 0, 0, 0
      ],
      color: "#afed23"
    },
    {
      locationName: "EInfochips",
      key: "EInfochips",
      total: 354,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 75, 75,
        0, 0, 162, 35, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 60, 0, 0, 0, 3
      ],
      color: "#eeda12"
    }
  ],
  baseTime: {
    start: "2024-09-26T00:00:00.000+05:30",
    end: "2024-12-24T23:59:59.999+05:30",
    mode: "custom"
  },
  dataSeries: ["Nonjinmul Beach", "Hanwha Vision (HQ)", "EInfochips"],
  icon: createElement(IconRuleShoppingCart),
  ...commonProps
};

export const previewShoppingCartInUse: ChartCardProps = {
  title: "Shopping carts in use",
  analyticsData: [
    {
      locationName: "Nonjinmul Beach",
      key: "Nonjinmul Beach",
      total: 400,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 10, 20, 0, 120, 30, 40, 0, 0, 0, 0, 0, 0, 155, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 20, 20, 4
      ],
      color: "#ff6d10"
    },
    {
      locationName: "Hanwha Vision (HQ)",
      key: "Hanwha Vision (HQ)",
      total: 1786,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 23, 3, 55, 0, 45, 23, 77, 4, 5, 22,
        44, 55, 6, 21, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30, 50, 0, 0, 0
      ],
      color: "#afed23"
    },
    {
      locationName: "EInfochips",
      key: "EInfochips",
      total: 354,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 75, 75,
        0, 0, 162, 35, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 60, 0, 0, 0, 3
      ],
      color: "#eeda12"
    }
  ],
  baseTime: {
    start: "2024-09-26T00:00:00.000+05:30",
    end: "2024-12-24T23:59:59.999+05:30",
    mode: "custom"
  },
  dataSeries: ["Nonjinmul Beach", "Hanwha Vision (HQ)", "EInfochips"],
  icon: createElement(IconRuleShoppingCart),
  ...commonProps
};

export const previewShoppingCartQueues: ChartCardProps = {
  title: "Shopping cart queues",
  analyticsData: [
    {
      locationName: "Nonjinmul Beach",
      key: "Nonjinmul Beach",
      total: 400,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 10, 20, 0, 120, 30, 40, 0, 0, 0, 0, 0, 0, 155, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 20, 20, 4
      ],
      color: "#ff6d10"
    },
    {
      locationName: "Hanwha Vision (HQ)",
      key: "Hanwha Vision (HQ)",
      total: 1786,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 23, 3, 55, 0, 45, 23, 77, 4, 5, 22,
        44, 55, 6, 21, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30, 50, 0, 0, 0
      ],
      color: "#afed23"
    },
    {
      locationName: "EInfochips",
      key: "EInfochips",
      total: 354,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 75, 75,
        0, 0, 162, 35, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 60, 0, 0, 0, 3
      ],
      color: "#eeda12"
    }
  ],
  baseTime: {
    start: "2024-09-26T00:00:00.000+05:30",
    end: "2024-12-24T23:59:59.999+05:30",
    mode: "custom"
  },
  dataSeries: ["Nonjinmul Beach", "Hanwha Vision (HQ)", "EInfochips"],
  icon: createElement(IconRuleShoppingCart),
  ...commonProps
};

export const previewCumulativeVehicleCount: ChartCardProps = {
  title: "Shopping carts in use",
  analyticsData: [
    {
      locationName: "Nonjinmul Beach",
      key: "Nonjinmul Beach",
      total: 400,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 10, 20, 0, 120, 30, 40, 0, 0, 0, 0, 0, 0, 155, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 20, 20, 4
      ],
      color: "#ff6d10"
    },
    {
      locationName: "Hanwha Vision (HQ)",
      key: "Hanwha Vision (HQ)",
      total: 1786,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 23, 3, 55, 0, 45, 23, 77, 4, 5, 22,
        44, 55, 6, 21, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30, 50, 0, 0, 0
      ],
      color: "#afed23"
    },
    {
      locationName: "EInfochips",
      key: "EInfochips",
      total: 354,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 75, 75,
        0, 0, 162, 35, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 60, 0, 0, 0, 3
      ],
      color: "#eeda12"
    }
  ],
  baseTime: {
    start: "2024-09-26T00:00:00.000+05:30",
    end: "2024-12-24T23:59:59.999+05:30",
    mode: "custom"
  },
  dataSeries: ["Nonjinmul Beach", "Hanwha Vision (HQ)", "EInfochips"],
  icon: createElement(IconRuleCrowd),
  ...commonProps
};

export const previewVehicleQueues: ChartCardProps = {
  title: "Vehicle queues",
  analyticsData: [
    {
      locationName: "Nonjinmul Beach",
      key: "Nonjinmul Beach",
      total: 400,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 10, 20, 0, 120, 30, 40, 0, 0, 0, 0, 0, 0, 155, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 20, 20, 4
      ],
      color: "#ff6d10"
    },
    {
      locationName: "Hanwha Vision (HQ)",
      key: "Hanwha Vision (HQ)",
      total: 1786,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 23, 3, 55, 0, 45, 23, 77, 4, 5, 22,
        44, 55, 6, 21, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30, 50, 0, 0, 0
      ],
      color: "#afed23"
    },
    {
      locationName: "EInfochips",
      key: "EInfochips",
      total: 354,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 75, 75,
        0, 0, 162, 35, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 60, 0, 0, 0, 3
      ],
      color: "#eeda12"
    }
  ],
  baseTime: {
    start: "2024-09-26T00:00:00.000+05:30",
    end: "2024-12-24T23:59:59.999+05:30",
    mode: "custom"
  },
  dataSeries: ["Nonjinmul Beach", "Hanwha Vision (HQ)", "EInfochips"],
  icon: createElement(IconRuleVehicle),
  ...commonProps
};

export const previewStoppedVehicleAnalytics: ChartCardProps = {
  title: "Stopped vehicle analytics",
  analyticsData: [
    {
      locationName: "Nonjinmul Beach",
      key: "Nonjinmul Beach",
      total: 400,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 10, 20, 0, 120, 30, 40, 0, 0, 0, 0, 0, 0, 155, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 20, 20, 4
      ],
      color: "#ff6d10"
    },
    {
      locationName: "Hanwha Vision (HQ)",
      key: "Hanwha Vision (HQ)",
      total: 1786,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 23, 3, 55, 0, 45, 23, 77, 4, 5, 22,
        44, 55, 6, 21, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30, 50, 0, 0, 0
      ],
      color: "#afed23"
    },
    {
      locationName: "EInfochips",
      key: "EInfochips",
      total: 354,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 75, 75,
        0, 0, 162, 35, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 60, 0, 0, 0, 3
      ],
      color: "#eeda12"
    }
  ],
  baseTime: {
    start: "2024-09-26T00:00:00.000+05:30",
    end: "2024-12-24T23:59:59.999+05:30",
    mode: "custom"
  },
  dataSeries: ["Nonjinmul Beach", "Hanwha Vision (HQ)", "EInfochips"],
  icon: createElement(IconRuleVehicle),
  ...commonProps
};

export const previewSlowTraffic: ChartCardProps = {
  title: "Slow traffic",
  analyticsData: [
    {
      locationName: "Nonjinmul Beach",
      key: "Nonjinmul Beach",
      total: 400,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 10, 20, 0, 120, 30, 40, 0, 0, 0, 0, 0, 0, 155, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 22, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 34, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 40, 20, 20, 4
      ],
      color: "#ff6d10"
    },
    {
      locationName: "Hanwha Vision (HQ)",
      key: "Hanwha Vision (HQ)",
      total: 1786,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 5, 0, 0, 0, 0, 0, 0, 23, 3, 55, 0, 45, 23, 77, 4, 5, 22,
        44, 55, 6, 21, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 30, 50, 0, 0, 0
      ],
      color: "#afed23"
    },
    {
      locationName: "EInfochips",
      key: "EInfochips",
      total: 354,
      chartData: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 75, 75,
        0, 0, 162, 35, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 10, 60, 0, 0, 0, 3
      ],
      color: "#eeda12"
    }
  ],
  baseTime: {
    start: "2024-09-26T00:00:00.000+05:30",
    end: "2024-12-24T23:59:59.999+05:30",
    mode: "custom"
  },
  dataSeries: ["Nonjinmul Beach", "Hanwha Vision (HQ)", "EInfochips"],
  icon: createElement(IconRuleTrafficJam),
  ...commonProps
};
